import React from 'react'

export interface AddressProps {
  country: 'NL' | 'BE'
  address: string
  postalCode: string
  city: string
}

export const Address: React.FC<AddressProps> = ({
  country,
  address,
  postalCode,
  city,
}) => {
  return (
    <div className="flex flex-row items-center justify-center gap-2 text-indigo-50">
      <span className="border-gray-42 font-heading flex h-6 w-6 flex-row items-center justify-center rounded border text-center text-xs">
        {country}
      </span>
      <div className="flex flex-1 flex-col">
        <span className="font-body text-sm">{address}</span>
        <span className="font-body text-gray-90 text-xs">{`${postalCode}, ${city}`}</span>
      </div>
    </div>
  )
}

export default Address
